// extracted by mini-css-extract-plugin
module.exports = {"form":"WealthForm_form__3ESuq","input":"WealthForm_input__2dkUF","submitButton":"WealthForm_submitButton__3WZ3b"};